import { contextHolderApi } from "./utils";

/**
 * 同步导出挂载全局的方法
 */
export default (funcName) => {
  if (contextHolderApi[funcName]) {
    return contextHolderApi[funcName];
  }
  throw new Error(`Can't find '${funcName}'!`);
};
